import Output from '../Output';

export default class Option extends Output {
    static default = 'true';
    static label   = '';
}